/**
 * Location Badge Component
 * 위치 정보를 표시하는 배지 컴포넌트
 */

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRegion } from "@/contexts/RegionContext";
import { australianStates, getSuburbsByState } from "@shared/suburbs";
import { MapPin } from "lucide-react";

interface LocationBadgeProps {
  variant?: "default" | "outline" | "secondary";
  showIcon?: boolean;
  onClick?: () => void;
  className?: string;
}

export function LocationBadge({
  variant = "outline",
  showIcon = true,
  onClick,
  className = "",
}: LocationBadgeProps) {
  const { selectedRegion, selectedSuburb } = useRegion();

  const stateInfo = australianStates.find((s) => s.id === selectedRegion);
  const suburbs = getSuburbsByState(selectedRegion);
  const suburbInfo = selectedSuburb
    ? suburbs.find((s) => s.id === selectedSuburb)
    : null;

  const displayText = suburbInfo
    ? `${suburbInfo.nameKo || suburbInfo.name}`
    : stateInfo?.nameKo || selectedRegion;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    // 위치 찾기는 탑 네비게이션에서만 사용
  };

  if (onClick || !onClick) {
    return (
      <Button
        variant="ghost"
        size="sm"
        onClick={handleClick}
        className={`gap-1.5 h-auto py-1 px-2 ${className}`}
      >
        {showIcon && <MapPin className="h-3.5 w-3.5" />}
        <span className="text-xs font-medium">{displayText}</span>
      </Button>
    );
  }

  return (
    <Badge variant={variant} className={`gap-1.5 ${className}`}>
      {showIcon && <MapPin className="h-3 w-3" />}
      <span>{displayText}</span>
    </Badge>
  );
}
